export default __webpack_public_path__ + "static/media/Manit03.f42edc6f.png";